<template>
  <v-card outlined class="app-card">
    <v-card-title class="app-card-title">Veículo Pesquisado</v-card-title>
    <v-card-text class="app-card-tcontent">
      <article class="rota-emocoes-card">
        <section class="rota-emocoes-card-content">
          <v-row no-gutters>
            <v-col :md="5" :sm="5" :xs="12" cols="12" class="mt-2">
              <strong class="info-text">
                Placa:
                <em>{{ veiculo.placa }}</em>
              </strong>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2">
              <strong class="info-text">
                Veículo:
                <em>{{ veiculo.modelo }}</em>
              </strong>
            </v-col>
            <v-col
              :md="3"
              :sm="3"
              :xs="12"
              cols="12"
              class="mt-2 text-md-right"
            >
              <strong class="info-text">
                Ano Fab/Mod:
                <em>{{ veiculo.anoFabricacaoModelo }}</em>
              </strong>
            </v-col>
            <v-col :md="5" :sm="5" :xs="12" cols="12" class="mt-2">
              <strong class="info-text">
                Empresa:
                <em>{{ veiculo.sebraeEmpresa.nomeEmpresa }}</em>
              </strong>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2">
              <strong class="info-text">
                Nome Fantasia:
                <em>{{ veiculo.sebraeEmpresa.nomeFantasia }}</em>
              </strong>
            </v-col>
            <v-col
              :md="3"
              :sm="3"
              :xs="12"
              cols="12"
              class="mt-2 text-sm-right text-md-right"
            >
              <strong class="info-text">
                UF Empresa:
                <em>{{ veiculo.sebraeEmpresa.uf }}</em>
              </strong>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2">
              <strong class="info-text">
                Data:
                <em>{{ veiculo.createdAt | date }}</em>
              </strong>
            </v-col>
          </v-row>
          <br />
          <strong style="font-weight: bold"
            >*Envio da informação do SEBRAE para o ARCE/CE</strong
          >
        </section>
      </article>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  //name: ResultadoRotaEmocoes,
  props: {
    veiculo: Object
  }
};
</script>
